// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.title-with-popover {
  display: flex;
  gap: 10px;
  align-items: center;
  margin-bottom: 8px;
}
.title-with-popover .small-title {
  color: inherit;
  font-size: inherit !important;
  font-weight: 400 !important;
}
.title-with-popover .BaSe--popover-card div:last-of-type .BaSe--small1 {
  font-size: 11px !important;
  color: var(--sebrae-gray);
}
.title-with-popover .BaSe--popover .BaSe--small1 {
  white-space: pre-wrap;
}`, "",{"version":3,"sources":["webpack://./src/components/title-with-popover/index.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;AACF;AACE;EACE,cAAA;EAEE,6BAAA;EACA,2BAAA;AAAN;AAKI;EACE,0BAAA;EACA,yBAAA;AAHN;AAOI;EACE,qBAAA;AALN","sourcesContent":[".title-with-popover {\r\n  display: flex;\r\n  gap: 10px;\r\n  align-items: center;\r\n  margin-bottom: 8px;\r\n\r\n  .small-title {\r\n    color: inherit;\r\n    font: {\r\n      size: inherit!important;\r\n      weight: 400!important;\r\n    }\r\n  }\r\n\r\n  .BaSe--popover-card div:last-of-type {\r\n    .BaSe--small1 {\r\n      font-size: 11px!important;\r\n      color: var(--sebrae-gray);\r\n    }\r\n  }\r\n  .BaSe--popover {\r\n    .BaSe--small1 {\r\n      white-space: pre-wrap;\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
